import { useContext, useMemo } from 'react';
import { ReportPeriodContext } from '../context/report-periods/report-periods';


export function useIsReportPeriodLocked(): boolean | null {
  const reportPeriodContext = useContext(ReportPeriodContext);

  return useMemo(() => {
    if (!reportPeriodContext.lastSelectedReportId) {
      return null;
    }
    const currentReportPeriod = reportPeriodContext.allReportPeriods.find(
      reportPeriod => reportPeriod.id === reportPeriodContext.lastSelectedReportId
    );
    return currentReportPeriod ? currentReportPeriod.locked : null;
  }, [reportPeriodContext.lastSelectedReportId, reportPeriodContext.allReportPeriods]);
}